import i18next from 'i18next';

import { LANGUAGE_KEYS } from '~constants/languages';

i18next.addResources(LANGUAGE_KEYS.CHILE, 'PaymentMethodsModal', {
  title: '¿Cómo Quieres Pagar hoy?',
  description: 'Después de elegir tu método de pago, podrás revisar y confirmar tu pedido.'
});

i18next.addResources(LANGUAGE_KEYS.SPAIN, 'PaymentMethodsModal', {
  description:
    'Para pago con tarjeta sólo aceptamos Visa y MasterCard. Por tu seguridad, trabajamos con doble autentificación, por lo que antes del cobro te llegará un SMS de tu banco con un código de autorización. Es importante que esta opción la tengas activada con tu entidad.'
});

i18next.addResources(LANGUAGE_KEYS.PORTUGAL, 'PaymentMethodsModal', {
  title: 'Como queres pagar hoje?',
  description:
    'Só são aceites pagamentos com cartão da Rede Visa ou MasterCard. Para vossa segurança, trabalhamos com dupla autenticação, pelo que receberás uma SMS da tua entidade bancária com código de autorização antes de cada transacção. É importante que tenha esta opção activa com a entidade emissora do cartão.'
});

i18next.addResources(LANGUAGE_KEYS.COSTA_RICA, 'PaymentMethodsModal', {
  description: 'Aceptamos tarjetas de crédito o débito Visa, Mastercard o American Express'
});

i18next.addResources(LANGUAGE_KEYS.PANAMA, 'PaymentMethodsModal', {
  description: 'Aceptamos tarjetas de crédito o débito Visa, Mastercard o American Express'
});
